import {
  all, call, put, takeLatest,
} from 'redux-saga/effects'
import { ReturnCall } from '../types'
import { actions } from './LossState'
import { actions as appActions } from '../state'
import * as api from './LossApi'
import { PayloadAction } from '@reduxjs/toolkit'
import {
  ProductLocation, ValidateSupervisorBadgeParams, productDescriptionDto, LossDto,
} from './LossTypes'
import { toast } from 'react-toastify'

export function* validateSupervisorBadge({ payload }: PayloadAction<ValidateSupervisorBadgeParams>) {
  const { badge, setError, onSuccess } = payload
  yield put(appActions.isLoading(true))

  try {
    const response: ReturnCall<typeof api.validateSupervisorBadge> = yield call(
      api.validateSupervisorBadge,
      badge,
    )

    if (!response.isOk) {
      setError('Crachá inválido')
      return
    }

    yield put(actions.updateLossState({ key: 'badge', value: badge }))
    onSuccess()
  } catch (error: any) {
    setError('Falha ao validar o crachá do supervisor!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getProductDescription({ payload }: PayloadAction<productDescriptionDto>) {
  const { barcode, getProductList, onSuccess } = payload
  yield put(appActions.isLoading(true))

  try {
    const response: ReturnCall<typeof api.getProductDescription> = yield call(
      api.getProductDescription,
      barcode,
    )

    if (!response.isOk) {
      toast.error(response?.data?.data?.message || 'Falha ao buscar descrição do produto')
      return
    }

    yield put(actions.updateLossState({ key: 'productDescription', value: response.data }))
    onSuccess()
    getProductList()
  } catch (error: any) {
    toast.error('Falha ao buscar o produto')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getProductLocation({ payload }: PayloadAction<ProductLocation>) {
  const {
    barcode, fcId, setError, onSuccess,
  } = payload
  yield put(appActions.isLoading(true))

  try {
    const response: ReturnCall<typeof api.getProductLocation> = yield call(
      api.getProductLocation,
      barcode,
      fcId,
    )

    if (!response.isOk) {
      setError('Nenhuma localização encontrada')
      yield put(actions.updateLossState({ key: 'addressList', value: [] }))
      return
    }

    yield put(actions.updateLossState({ key: 'addressList', value: response.data }))
    onSuccess()
  } catch (error: any) {
    toast.error('Falha ao buscar localização do produto')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* sendLossAdjustment({ payload }: PayloadAction<LossDto>) {
  const { onSuccess, LossAdjustment, reset } = payload
  yield put(appActions.isLoading(true))

  try {
    const response: ReturnCall<typeof api.sendLossAdjustment> = yield call(
      api.sendLossAdjustment,
      LossAdjustment,
    )

    if (!response.isOk) {
      toast.error('Falha ao registrar avaria(s)')
      return
    }

    onSuccess()
    reset()
    toast.success('Avaria(s) registrada(s) com sucesso')
  } catch (error: any) {
    toast.error('Falha ao enviar ajuste de perda')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export default function* () {
  yield all([
    takeLatest(actions.validateSupervisorBadge.type, validateSupervisorBadge),
    takeLatest(actions.getProductDescription.type, getProductDescription),
    takeLatest(actions.getProductLocation.type, getProductLocation),
    takeLatest(actions.sendLossAdjustment.type, sendLossAdjustment),
  ])
}
